window.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.checkbox__input').forEach((input) => {
        input.addEventListener('change', () => {
            if (input.required) {
                let field = input.parentElement.parentElement.classList;

                if (input.checked) {
                    field.remove('checkbox--invalid');
                } else {
                    field.add('checkbox--invalid');
                }
            }
        });
    });
});